import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { SEODataRetriever, SEOData } from '@care/mfe-data-transfer-seo';
import { TrafficSource } from '@/types/seeker';
import { useAppDispatch } from '../AppState';

export const useRetrieveSeoMfeSharedData = () => {
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [data, setData] = useState<SEOData | undefined>(undefined);

  useEffect(() => {
    const SEORetriever = new SEODataRetriever();
    setData(SEORetriever.retrieveData());

    setIsFetching(false);
  }, []);

  return {
    isFetching,
    data,
  };
};

export const useSeoMfeSharedData = () => {
  const dispatch = useAppDispatch();
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const { data } = useRetrieveSeoMfeSharedData();
  const router = useRouter();
  const { query } = router;
  const { fromSeoPage } = query;

  const comesFromSeoPage = fromSeoPage === 'true';

  useEffect(() => {
    if (data && comesFromSeoPage) {
      const { zipcodeData } = data;

      if (zipcodeData) {
        dispatch({ type: 'setZipcode', zipcode: zipcodeData.zipcode });
        dispatch({
          type: 'setCityAndState',
          city: zipcodeData.city,
          state: zipcodeData.state,
        });

        dispatch({
          type: 'setDataTransferMetadata',
          dataTransferMetadata: { zipcodeSupplied: true },
        });
      }

      dispatch({ type: 'setSource', source: TrafficSource.SEO });
    }

    setIsFetching(false);
  }, [data, comesFromSeoPage]);

  return {
    isFetching,
  };
};
